var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCE058",
    fillRule: "evenodd",
    d: "M12 18.48a6.48 6.48 0 1 0 0-12.96a6.48 6.48 0 0 0 0 12.96m0 .377a6.857 6.857 0 1 0 0-13.714a6.857 6.857 0 0 0 0 13.714",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 18.103a6.103 6.103 0 1 0 0-12.206a6.103 6.103 0 0 0 0 12.206m0 .377a6.48 6.48 0 1 0 0-12.96a6.48 6.48 0 0 0 0 12.96",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.571 9H9.428v1.286h3.129l-3.129 3.729V15h5.143v-1.286h-3.077L14.571 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.167d6605d3cc85d1e8ab27526a6ce8ed.svg";
export { ForwardRef as ReactComponent };